export const ADD_WALLET_ATTRIBUTES_CONSTANT = {
  partner: {
    type: 'select',
    key: 'partner_id',
    label: 'Partner',
  },
  sender: {
    type: 'select',
    key: 'sender_id',
    label: 'Sender',
  },
  country: {
    type: 'select',
    key: 'country',
    label: 'Country',
  },
  currency: {
    type: 'text',
    key: 'currency',
    label: 'Currency',
  },
} as const;
